import * as XLSX from 'xlsx';
import { REPORT_COLUMNS, buildReportTotals, formatDateTime } from './attendanceReportBuilder';

export function generateAttendanceReportExcel({ report, range, filters, generatedBy }) {
  const title = 'MONTHLY ATTENDANCE SUMMARY REPORT';
  const activeFilters = Object.entries(filters || {})
    .filter(([, v]) => v && v !== 'All')
    .map(([k, v]) => `${k}: ${v}`)
    .join('   |   ') || 'None';

  const headerRows = [
    [title],
    [`Period: ${range?.from || ''}  to  ${range?.to || ''}`],
    [`Filters: ${activeFilters}`],
    [`Generated: ${formatDateTime()}${generatedBy ? `   |   By: ${generatedBy}` : ''}`],
    ['Based on recorded punches only. Absence, leave and holidays are NOT included.'],
    [],
  ];

  const columnHeader = REPORT_COLUMNS.map((c) => c.label);
  const bodyRows = report.map((row) =>
    REPORT_COLUMNS.map((c) => {
      const v = row[c.key];
      if (c.numeric) return Number(v) || 0;
      return v === null || v === undefined ? '' : v;
    })
  );

  const totals = buildReportTotals(report);
  const totalRow = REPORT_COLUMNS.map((c) => {
    const v = totals[c.key];
    if (c.numeric) return Number(v) || 0;
    return v === null || v === undefined ? '' : v;
  });

  const aoa = [...headerRows, columnHeader, ...bodyRows, [], totalRow];
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = REPORT_COLUMNS.map((c) => ({ wch: c.width || 14 }));

  // Merge the title/meta lines across the full table width.
  const lastCol = REPORT_COLUMNS.length - 1;
  ws['!merges'] = headerRows
    .map((_, i) => ({ s: { r: i, c: 0 }, e: { r: i, c: lastCol } }))
    .filter((_, i) => i < 5);

  // Freeze everything above and left of the first data cell.
  ws['!freeze'] = { xSplit: 2, ySplit: headerRows.length + 1 };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Attendance Summary');

  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([out], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const filename = `Attendance_Summary_${range?.from || ''}_to_${range?.to || ''}.xlsx`;

  return { blob, filename };
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Give the browser a moment before revoking.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}